<div class="clinic-exam-builder">

    <!-- ============ template header: title + doctors + actions ============ -->
    <div class="builder-head">
        <label class="field">
            <span>שם הבדיקה</span>
            <input type="text" [(ngModel)]="title" placeholder="למשל: בדיקת אף אוזן גרון" dir="auto" />
        </label>

        <div class="doctors">
            <span class="field-label">רופאים שיראו את הבדיקה  </span>
            <div class="doctor-select-list">
                <label *ngFor="let d of doctors" class="doctor-select-item">
                    <input type="checkbox" class="custom-check -sq" [checked]="isSelected(d.UID)"
                        (change)="toggleDoctor(d.UID)" />
                    <i class="customInput-display -sq"></i>
                    <span>{{ d.Name || d.EngName || ('UID ' + d.UID) }}</span>
                </label>
                <div *ngIf="!doctors.length" class="empty">לא נמצאו רופאים.</div>
            </div>
        </div>

        <div class="actions">
            <button type="button" class="blue-btn" [disabled]="!title || loading" (click)="save()">
                {{ editingId ? 'עדכון' : 'יצירה' }}
            </button>
            <button type="button" class="orange-btn" *ngIf="editingId" [disabled]="loading" (click)="resetForm()">
                ביטול
            </button>
        </div>
    </div>

    <div class="builder-body">

        <!-- ============ palette ============ -->
        <div class="palette-panel">
            <h3>סוגי אינפוטים</h3>
            <p class="hint">גרור לתוך הבדיקה, או לחץ להוספה בסוף</p>
            <div class="palette-list" cdkDropList #paletteList="cdkDropList" [cdkDropListData]="palette"
                [cdkDropListConnectedTo]="[canvasList]" [cdkDropListSortingDisabled]="true">
                <div class="palette-chip" *ngFor="let p of palette" cdkDrag [cdkDragData]="p"
                    (click)="addFromPalette(p)">
                    <span>{{ p.label }}</span>
                    <div class="palette-chip drag-preview" *cdkDragPreview>{{ p.label }}</div>
                </div>
            </div>
        </div>

        <!-- ============ canvas: live preview of the exam ============ -->
        <div class="canvas-panel">
            <h3>הבדיקה כפי שהרופא יראה אותה</h3>

            <div class="canvas l-flex-w t-boxMargin--spacebyPadding summary" cdkDropList #canvasList="cdkDropList"
                [cdkDropListData]="fields" (cdkDropListDropped)="dropOnCanvas($event)">

                <div class="canvas-field" *ngFor="let f of fields; let i = index" [ngClass]="f.Width"
                    [class.selected]="selectedIndex === i" (click)="select(i)" cdkDrag>

                    <div class="field-toolbar">
                        <button type="button" class="tool-btn" cdkDragHandle matTooltip="גרור למיקום">✥</button>
                        <button type="button" class="tool-btn" (click)="moveUp(i); $event.stopPropagation()"
                            matTooltip="למעלה">▲</button>
                        <button type="button" class="tool-btn" (click)="moveDown(i); $event.stopPropagation()"
                            matTooltip="למטה">▼</button>
                        <button type="button" class="tool-btn -danger"
                            (click)="confirmRemoveField(i); $event.stopPropagation()" matTooltip="הסר">✕</button>
                    </div>

                    <!-- section header -->
                    <div class="w100 header-preview" *ngIf="f.FieldType === 'header'">
                        <h2 class="section-header">{{ f.Label }}</h2>
                        <div class="sep-8"></div>
                    </div>

                    <!-- free text + auto text -->
                    <section class="m-box fulltext" *ngIf="f.FieldType === 'text'">
                        <h2>{{ f.Label }}</h2>
                        <textarea class="scroller scroller-intro fulltext" disabled
                            [style.min-height]="f.Config.minHeight || '10em'"></textarea>
                        <button class="t-btn-edit" type="button" disabled>Auto Text</button>
                    </section>

                    <!-- yes / no + optional comment -->
                    <section class="m-box" *ngIf="f.FieldType === 'yesno'">
                        <h2>{{ f.Label }}</h2>
                        <div class="anatomy-twin-radios" style="margin-block-start: 0.3em;">
                            <label class="observe">
                                <input type="radio" class="custom-check customInput" disabled />
                                <i class="customInput-display"></i>
                                <span>{{ f.Config.left || 'Normal' }}</span>
                            </label>
                            <label class="not-observe">
                                <input type="radio" class="custom-check customInput" disabled />
                                <i class="customInput-display"></i>
                                <span>{{ f.Config.right || 'Abnormal' }}</span>
                            </label>
                        </div>
                        <div class="commDiv" *ngIf="f.Config.comment">
                            <label>Comments</label>
                            <textarea class="fulltext" disabled style="margin-block-start: 1em; border: revert;"></textarea>
                            <button class="t-btn-edit" type="button" disabled
                                *ngIf="f.autoTexts.length">Auto Text</button>
                        </div>
                    </section>

                    <!-- number + unit -->
                    <section class="m-box" *ngIf="f.FieldType === 'number'">
                        <h2>{{ f.Label }}</h2>
                        <div style="margin: 1em; padding: 0.5em; text-align: -webkit-center;">
                            <span class="t-field t-field--number">
                                <input class="t-field-text" disabled />
                                <span class="t-field-desc">{{ f.Config.unit }}</span>
                            </span>
                        </div>
                    </section>

                    <!-- select: the collapsed control only ever shows one option, so the
                         defined options are listed underneath for the admin to check -->
                    <section class="m-box" *ngIf="f.FieldType === 'select'">
                        <h2>{{ f.Label }}</h2>
                        <select class="t-select t-field select-preview" disabled>
                            <option *ngFor="let o of f.Config.options" dir="auto">{{ o }}</option>
                        </select>
                        <div class="option-list" *ngIf="f.Config.options?.length">
                            <span class="option-chip" *ngFor="let o of f.Config.options" dir="auto">{{ o }}</span>
                        </div>
                        <div class="empty" *ngIf="!f.Config.options?.length">לא הוגדרו אפשרויות</div>
                    </section>

                    <!-- picklist: textarea + inline clickable items -->
                    <section class="m-box fulltext" *ngIf="f.FieldType === 'picklist'">
                        <h2>{{ f.Label }}</h2>
                        <div class="picklist-preview">
                            <textarea class="scroller fulltext" disabled style="min-height: 6em;"></textarea>
                            <div class="picklist-items">
                                <div class="picklist-item" *ngFor="let a of f.autoTexts">{{ a.Content }}</div>
                                <div class="empty" *ngIf="!f.autoTexts.length">לא הוגדרו פריטים</div>
                            </div>
                        </div>
                    </section>

                    <!-- table -->
                    <section class="m-box" *ngIf="f.FieldType === 'table'">
                        <h2>{{ f.Label }}</h2>
                        <div class="l-table-auto">
                            <div class="l-row table-row" *ngFor="let r of f.Config.rows">
                                <div class="l-td-m table-row-label">{{ r.label }}</div>
                                <div class="l-td-m">
                                    <div class="anatomy-twin-radios">
                                        <label class="observe">
                                            <input type="radio" class="custom-check customInput" disabled />
                                            <i class="customInput-display"></i>
                                            <span>{{ f.Config.left || 'Normal' }}</span>
                                        </label>
                                        <label class="not-observe">
                                            <input type="radio" class="custom-check customInput" disabled />
                                            <i class="customInput-display"></i>
                                            <span>{{ f.Config.right || 'Abnormal' }}</span>
                                        </label>
                                    </div>
                                </div>
                                <div class="l-td-m" *ngIf="f.Config.comment">
                                    <textarea class="fulltext" disabled style="border: revert;"></textarea>
                                </div>
                            </div>
                            <div class="empty" *ngIf="!f.Config.rows?.length">לא הוגדרו שורות</div>
                        </div>
                    </section>

                    <!-- summary (rich text) -->
                    <section class="m-box" *ngIf="f.FieldType === 'summary'">
                        <h2>{{ f.Label }}</h2>
                        <div class="rich-placeholder">עורך טקסט עשיר</div>
                        <button class="t-btn-edit" type="button" disabled>Auto Text</button>
                    </section>

                </div>

                <div class="canvas-empty" *ngIf="!fields.length">
                    גרור לכאן אינפוטים מהרשימה שמימין כדי לבנות את הבדיקה
                </div>
            </div>

            <!-- removed fields: soft-deleted, restorable, answers kept -->
            <div class="removed-fields" *ngIf="removedFields.length">
                <button type="button" class="removed-toggle" (click)="showRemoved = !showRemoved">
                    {{ showRemoved ? '▾' : '▸' }} שדות שהוסרו ({{ removedFields.length }})
                </button>
                <div class="removed-list" *ngIf="showRemoved">
                    <p class="hint">
                        השדות האלה לא מופיעים בבדיקות חדשות, אבל התוכן שהוזן בהם בבדיקות קיימות נשמר ומודפס.
                    </p>
                    <div class="removed-item" *ngFor="let f of removedFields; let i = index">
                        <span class="removed-item-label">{{ f.Label }}</span>
                        <span class="removed-item-type">{{ typeLabel(f.FieldType) }}</span>
                        <button type="button" class="blue-btn -sm" (click)="restoreField(i)">שחזור</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- ============ properties of the selected field ============ -->
        <div class="props-panel">
            <h3>מאפייני האינפוט</h3>

            <div *ngIf="!selected" class="empty">בחר אינפוט בבדיקה כדי לערוך אותו.</div>

            <ng-container *ngIf="selected as f">
                <label class="field">
                    <span>כותרת</span>
                    <input type="text" [(ngModel)]="f.Label" dir="auto" />
                </label>

                <label class="field" *ngIf="f.FieldType !== 'header'">
                    <span>רוחב</span>
                    <select [(ngModel)]="f.Width">
                        <option *ngFor="let w of widths" [value]="w">{{ w }}</option>
                    </select>
                </label>

                <!-- number -->
                <label class="field" *ngIf="f.FieldType === 'number'">
                    <span>יחידה</span>
                    <input type="text" [(ngModel)]="f.Config.unit" placeholder="cm" />
                </label>

                <!-- yes/no -->
                <ng-container *ngIf="f.FieldType === 'yesno'">
                    <label class="field">
                        <span>תווית ימנית</span>
                        <input type="text" [(ngModel)]="f.Config.left" dir="auto" />
                    </label>
                    <label class="field">
                        <span>תווית שמאלית</span>
                        <input type="text" [(ngModel)]="f.Config.right" dir="auto" />
                    </label>
                    <label class="check-field">
                        <input type="checkbox" class="custom-check -sq" [(ngModel)]="f.Config.comment" />
                        <i class="customInput-display -sq"></i>
                        <span>שדה הערות</span>
                    </label>
                </ng-container>

                <!-- select options -->
                <ng-container *ngIf="f.FieldType === 'select'">
                    <span class="field-label">אפשרויות</span>
                    <div class="repeat-row" *ngFor="let o of f.Config.options; let i = index; trackBy: trackByIndex">
                        <input type="text" [(ngModel)]="f.Config.options[i]" dir="auto" />
                        <button type="button" class="orange-btn -sm" (click)="removeOption(f, i)">הסר</button>
                    </div>
                    <button type="button" class="blue-btn -sm" (click)="addOption(f)">הוסף אפשרות</button>
                </ng-container>

                <!-- table rows + labels -->
                <ng-container *ngIf="f.FieldType === 'table'">
                    <label class="field">
                        <span>תווית ימנית</span>
                        <input type="text" [(ngModel)]="f.Config.left" dir="auto" />
                    </label>
                    <label class="field">
                        <span>תווית שמאלית</span>
                        <input type="text" [(ngModel)]="f.Config.right" dir="auto" />
                    </label>
                    <label class="check-field">
                        <input type="checkbox" class="custom-check -sq" [(ngModel)]="f.Config.comment" />
                        <i class="customInput-display -sq"></i>
                        <span>עמודת הערות</span>
                    </label>
                    <span class="field-label">שורות</span>
                    <div class="repeat-row" *ngFor="let r of f.Config.rows; let i = index; trackBy: trackByIndex">
                        <input type="text" [(ngModel)]="r.label" dir="auto" />
                        <button type="button" class="orange-btn -sm" (click)="removeTableRow(f, i)">הסר</button>
                    </div>
                    <button type="button" class="blue-btn -sm" (click)="addTableRow(f)">הוסף שורה</button>
                </ng-container>

                <!-- auto texts / picklist items -->
                <ng-container *ngIf="showsAutoTextEditor(f)">
                    <span class="field-label">{{ autoTextLabel(f) }}</span>
                    <div class="repeat-row" *ngFor="let a of f.autoTexts; let i = index; trackBy: trackByIndex">
                        <textarea [(ngModel)]="a.Content" rows="2" dir="auto"></textarea>
                        <button type="button" class="orange-btn -sm" (click)="removeAutoText(f, i)">הסר</button>
                    </div>
                    <button type="button" class="blue-btn -sm" (click)="addAutoText(f)">
                        {{ f.FieldType === 'picklist' ? 'הוסף פריט' : 'Add Auto Text' }}
                    </button>
                </ng-container>
            </ng-container>
        </div>
    </div>

    <!-- ============ existing builder templates ============ -->
    <div class="templates-panel">
        <h3>בדיקות קיימות</h3>
        <div class="template-list" *ngIf="templates.length">
            <div class="template-card" *ngFor="let t of templates" [class.editing]="t.ClinicTemplateID === editingId">
                <div class="template-card-title">{{ t.Title }}</div>
                <div class="template-card-meta">{{ t.FieldCount || 0 }} אינפוטים</div>
                <div class="template-card-docs">
                    <span *ngFor="let uid of t.assignedUIDs; let last = last">{{ docLabel(uid) }}{{ last ? '' : ', ' }}</span>
                    <span *ngIf="!t.assignedUIDs?.length" class="empty">לא הוקצתה לרופאים</span>
                </div>
                <div class="template-card-actions">
                    <button type="button" class="blue-btn" [disabled]="loading" (click)="edit(t)">עריכה</button>
                    <button type="button" class="orange-btn" [disabled]="loading" (click)="confirmDelete(t)">מחיקה</button>
                </div>
            </div>
        </div>
        <div *ngIf="!templates.length" class="empty">עוד לא נבנו בדיקות.</div>
    </div>
</div>

<!-- ============ confirm: remove a field ============ -->
<div *ngIf="showDeleteFieldConfirm" class="t-popup popup-patientDetails popup-centered">
    <div class="t-popup-frame">
        <div class="t-popup-body">
            <button class="t-btn-popup-close" aria-label="close popup" (click)="cancelRemoveField()"></button>
            <h2 style="color: #D7A95B; text-align: center;">
                להסיר את "{{ fields[fieldToDeleteIndex]?.Label }}" מהבדיקה?
                <br />
                האינפוט לא יופיע בבדיקות חדשות. בדיקות שכבר מולאו ישמרו את התוכן שהוזן בו.
            </h2>
            <div style="display: flex; justify-content: center;">
                <button class="blue-btn" (click)="doRemoveField()">כן</button>
                <button class="orange-btn" style="margin-left: 2em" (click)="cancelRemoveField()">לא</button>
            </div>
        </div>
    </div>
</div>

<!-- ============ confirm: delete a whole template ============ -->
<div *ngIf="showDeleteConfirm" class="t-popup popup-patientDetails popup-centered">
    <div class="t-popup-frame">
        <div class="t-popup-body">
            <button class="t-btn-popup-close" aria-label="close popup" (click)="cancelDelete()"></button>
            <h2 style="color: #D7A95B; text-align: center;">
                למחוק את הבדיקה "{{ templateToDelete?.Title }}"?
                <br />
                אם כבר בוצעו בדיקות לפי התבנית הזאת, היא תוסר מהרשימות אבל הבדיקות עצמן יישמרו וימשיכו להיפתח ולהודפס.
            </h2>
            <div style="display: flex; justify-content: center;">
                <button class="blue-btn" [disabled]="loading" (click)="doDelete()">כן</button>
                <button class="orange-btn" style="margin-left: 2em" [disabled]="loading" (click)="cancelDelete()">לא</button>
            </div>
        </div>
    </div>
</div>
